import { useEffectOnce } from 'react-use';
import { Host } from '../../Host';

export const RedirectToHref = ({ href }: { href: string }) => {
    useEffectOnce(() => {
        window.location.href = href.startsWith('/') ? Host.baseUrl + href : href;
    });
    return null;
};
